**Kurtosis** measures the weightage of the distribution tails with reference to
the all-around distribution curve, where excess kurtosis represents the fat
tail in return distribution. Positive (negative) kurtosis implies that there are
more (fewer) extremely larger gains (losses) than a normal distribution.
Kurtosis focuses on the extreme values in either tail.
